import { intervalToDuration } from 'date-fns';

const getAllTimeOptions = (restaurantHoursToday) =>
  restaurantHoursToday?.map((time) => {
    const timeStart = time?.open;
    const timeEnd = time?.close;
    const durationStart = intervalToDuration({
      start: 0,
      end: timeStart * 1000,
    });
    const durationEnd = intervalToDuration({ start: 0, end: timeEnd * 1000 });
    const zeroPad = (num) => String(num).padStart(2, '0');

    const startHours =
      durationStart.hours > 12 ? durationStart.hours - 12 : durationStart.hours;
    const endHours =
      durationEnd.hours > 12 ? durationEnd.hours - 12 : durationEnd.hours;

    let formattedDurationStart;
    let formattedDurationEnd;

    if (durationStart.minutes === 0) {
      formattedDurationStart = `${startHours} ${
        durationStart.hours < 12 ? ' AM' : ' PM'
      }`;
    } else {
      formattedDurationStart = [startHours, durationStart.minutes]
        .map(zeroPad)
        .join(':')
        .concat(durationStart.hours < 12 ? ' AM' : ' PM');
    }
    if (durationEnd.minutes === 0) {
      formattedDurationEnd = `${endHours} ${
        durationEnd.hours < 12 ? ' AM' : ' PM'
      }`;
    } else {
      formattedDurationEnd = [endHours, durationEnd.minutes]
        .join(':')
        .concat(durationEnd.hours < 12 ? ' AM' : ' PM');
    }

    return (
      `(${formattedDurationStart} - ${formattedDurationEnd})` +
      '\xa0\xa0\xa0\xa0'
    );
  });

export default getAllTimeOptions;
